'use client';
import Navigation, {
  NavigationProps as BaseNavigationProps,
} from '@repo/ui/src/components/Navigation';
import NavbarBrand from '@components/Navbar/_Brand';
import NavbarShoppingCart from '@components/Navbar/_ShoppingCart';
import UserAvatar from '@components/Navbar/_UserAvatar';
import SocialLinks from '@components/SocialLinks';
import { useKeyboardNavigation } from '@hooks/useKeyboardNavigation';
import { useOnRouteChange } from '@hooks/useOnRouteChange';
import { useCustomer } from '@hooks/customer';
import { useLogout } from '@hooks/auth';
import { useVipAccess } from '@hooks/customer/useVipAccess';
import { getTZDate } from '@repo/ui/src/components/SiteWideBanner/_CountdownClock';
import LanguageSelectorData from '@components/LanguageSelector/LanguageSelectorData.json';

// Extend the base props with traeger-specific requirements
export type NavigationProps = Omit<
  BaseNavigationProps,
  | 'NavbarBrand'
  | 'NavbarShoppingCart'
  | 'UserAvatar'
  | 'useKeyboardNavigation'
  | 'useOnRouteChange'
  | 'useCustomer'
  | 'useLogout'
  | 'SocialLinks'
  | 'vip'
>;

// Re-export types that other components might need
export type { NavItemProps } from '@repo/ui/src/components/Navigation';
export { isDropdown, useNavigationContext } from '@repo/ui/src/components/Navigation';

const TraegerNavigation = (props: NavigationProps) => {
  const { vip } = useVipAccess();
  return (
    <Navigation
      {...props}
      regions={LanguageSelectorData.regions}
      NavbarBrand={NavbarBrand}
      NavbarShoppingCart={NavbarShoppingCart}
      UserAvatar={UserAvatar}
      useKeyboardNavigation={useKeyboardNavigation}
      useOnRouteChange={useOnRouteChange}
      useCustomer={useCustomer}
      useLogout={useLogout}
      SocialLinks={SocialLinks}
      getTZDate={getTZDate}
      vip={vip}
    />
  );
};

export default TraegerNavigation;
